import { useCallback, useState } from "react";
import { toast } from "react-toastify";
import { getSessionActions } from "../status/getSessionActions";
import { SessionDrawerState } from "../types/actions";
import { WebinarSession } from "../types/models";

/**
 * Controls create / edit / duplicate drawer open state.
 * Edit/duplicate keep the clicked row session — no posts refetch.
 */
export function useSessionDrawer() {
  const [drawer, setDrawer] = useState<SessionDrawerState>(null);

  const openCreate = useCallback(() => {
    setDrawer({ mode: "create", session: null });
  }, []);

  const openEdit = useCallback((session: WebinarSession) => {
    const actions = getSessionActions(session);
    if (!actions.canEdit) {
      toast.error(
        session.status === "live"
          ? "Live sessions cannot be edited"
          : "This session cannot be edited"
      );
      return;
    }
    setDrawer({ mode: "edit", session });
  }, []);

  const openDuplicate = useCallback((session: WebinarSession) => {
    setDrawer({ mode: "duplicate", session });
  }, []);

  const closeDrawer = useCallback(() => {
    setDrawer(null);
  }, []);

  return {
    drawer,
    openCreate,
    openEdit,
    openDuplicate,
    closeDrawer,
    setDrawer,
  };
}
